import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUsersContext } from '../../../contexts/users.tsx';
import LoginBody from './body.tsx';
import LoginHeader from './header.tsx';

const Login = () => {
    const { isLoggedIn } = useUsersContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (isLoggedIn)
            navigate("/journal");
    }, [isLoggedIn, navigate]);

    if (isLoggedIn)
        return null;

    return (
        <>
            <LoginHeader />
            <LoginBody />
        </>
    );
};

export default Login;
